import "../styles/App.scss";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";

import AnalyticsRoutes from "./routes";
import ChunkErrorBoundary from "src/components/common/ChunkErrorBoundary";
import UpdateChecker from "src/UpdateChecker";
//TODO: fix the stale time.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60, // 60 minutes
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        closeButton={true}
        // pauseOnHover
        theme="colored"
      />
      <ChunkErrorBoundary>
        <AnalyticsRoutes />
      </ChunkErrorBoundary>
      <UpdateChecker />
    </QueryClientProvider>
  );
}
